
export default function GetInvolvedSection() {
  const opportunities = [
    {
      title: 'Student Council Representative',
      description: 'Represent your school on the CPVA Student Council and help shape policies',
      commitment: '10-15 hours/month',
      benefits: ['Leadership experience', 'Policy influence', 'Networking opportunities'],
      icon: 'ri-user-star-line'
    },
    {
      title: 'Peer Mentor Program',
      description: 'Guide and support incoming students through their academic journey',
      commitment: '5-8 hours/month',
      benefits: ['Teaching skills', 'Personal fulfillment', 'Recognition certificate'],
      icon: 'ri-hand-heart-line'
    },
    {
      title: 'Research Committee',
      description: 'Participate in student-led research initiatives and publications',
      commitment: '8-12 hours/month',
      benefits: ['Research experience', 'Publication opportunities', 'Academic recognition'],
      icon: 'ri-microscope-line'
    },
    {
      title: 'Event Planning Team',
      description: 'Help organize conferences, workshops, and networking events',
      commitment: '6-10 hours/month',
      benefits: ['Event management skills', 'Industry connections', 'Portfolio building'],
      icon: 'ri-calendar-event-line'
    },
    {
      title: 'Communications Team',
      description: 'Manage social media, newsletters, and student communications',
      commitment: '4-6 hours/month',
      benefits: ['Digital marketing skills', 'Content creation', 'Brand management'],
      icon: 'ri-megaphone-line'
    },
    {
      title: 'Advocacy Ambassador',
      description: 'Represent student interests in policy discussions and advocacy efforts',
      commitment: '8-10 hours/month',
      benefits: ['Policy knowledge', 'Government relations', 'Public speaking'],
      icon: 'ri-government-line'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Get Involved
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Take an active role in shaping the future of pharmacy and veterinary medicine. Join one of our volunteer opportunities and make a meaningful impact.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {opportunities.map((opportunity, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <i className={`${opportunity.icon} text-2xl text-blue-600`}></i>
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {opportunity.title}
              </h3>
              
              <p className="text-gray-600 mb-4">
                {opportunity.description}
              </p>

              <div className="mb-4">
                <div className="flex items-center text-sm text-gray-700 mb-2">
                  <i className="ri-time-line text-blue-500 mr-2"></i>
                  <span className="font-medium">Time Commitment:</span>
                  <span className="ml-1">{opportunity.commitment}</span>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-medium text-gray-900 mb-2">Benefits:</h4>
                <ul className="space-y-1">
                  {opportunity.benefits.map((benefit, benefitIndex) => (
                    <li key={benefitIndex} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>

              <button className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                Apply Now
              </button>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-green-600 to-blue-600 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">
            Questions About Getting Involved?
          </h3>
          <p className="text-green-100 mb-6">
            Contact our Student Engagement Coordinator for more information about volunteer opportunities
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer">
              Contact Us
            </button>
            <button className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">
              Download Info Package
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
